import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

import { ReactComponent as FileIcon } from "../../assets/Icons/file-text.svg";
import { useCredentials } from "../../contexts/Credentials";
import CredentialItem from "./CredentialItem";
import { useBasicInfo } from "../../contexts/BasicInfo";
import { useAlert } from "../../contexts/Alert";
import { trackClickEvent } from "../../mixpanel";

const ProfileCredentials = () => {
  const { handleOpen, fetchCredentials, list, fetchPsypact, editPsypact } =
    useCredentials();
  const { data } = useBasicInfo();
  const { sendAlert } = useAlert();
  const [psypactChecked, setPsypactChecked] = useState(
    data?.info?.psypact_provider || 0,
  );
  const [displayPsypact, setDisplayPsypact] = useState(false);
  const [loading, setLoading] = useState(true);

  const addNew = (credentialType = null) => {
    handleOpen(null, credentialType);
    trackClickEvent("Updated Profile Information", {
      component: "Credential Add New Section",
      page: "Edit Profile",
      button: "Add New"
    });
  };

  useEffect(() => {
    setPsypactChecked(data?.info?.psypact_provider || 0);
  }, [data]);

  useEffect(() => {
    fetchCredentials();
    fetchShowPsypact();
  }, []);

  const fetchShowPsypact = async () => {
    try {
      setLoading(true);
      const data = await fetchPsypact();
      setDisplayPsypact(data.data?.display_psypact_provider);
    } catch (error) {
      console.error("Error fetching Psypact status:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePsypactChange = async (event) => {
    const newCheckedStatus = event.target.checked;
    setPsypactChecked(newCheckedStatus);

    try {
      setLoading(true);
      await editPsypact({ psypact_provider: newCheckedStatus });
      sendAlert("Updated successfully", "success");
      trackClickEvent("Updated Profile Information", {
        component: "Credential PSYPACT Toggle",
        page: "Edit Profile",
        button: newCheckedStatus ? "Enable" : "Disable"
      });
      setLoading(false);
    } catch (error) {
      console.error("Error updating Psypact status:", error);
      setPsypactChecked(!newCheckedStatus);
      setLoading(false);
    }
  };

  return (
    <Paper
      sx={{
        p: 3,
        display: "flex",
        flexDirection: "column",
        gap: 3,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <FileIcon width={24} height={24} />
        <Typography variant="h4" ml={1}>
          Credentials
        </Typography>
      </Box>

      <Box
        sx={{
          borderWidth: "1px",
          borderStyle: "solid",
          borderColor: "border.main",
          p: 3,
          borderRadius: 2,
        }}
      >
        <Box
          sx={{
            mb: 1.5,
          }}
        >
          <Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography variant="h5">License:</Typography>
              <Button
                sx={{
                  p: 0,
                  "&:hover": {
                    backgroundColor: "transparent",
                  },
                }}
                onClick={() => addNew("license")}
              >
                Add new
              </Button>
            </Box>
            <Box component="ol" pl={2}>
              {list.reduce((acc, item) => {
                if (item.type === "license") {
                  return [...acc, <CredentialItem key={item.id} data={item} />];
                } else {
                  return acc;
                }
              }, [])}
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            mb: 1.5,
          }}
        >
          <Box>
            {/* <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography variant="h5">Pre-Licensure:</Typography>
              {list.filter((item) => item.type === "pre-license").length < 1 ? (
                <Button
                  sx={{
                    p: 0,
                    "&:hover": {
                      backgroundColor: "transparent",
                    },
                  }}
                  onClick={() => addNew('pre-license')}
                >
                  Add new
                </Button>
              ) : null}
            </Box> */}
            <Box component="ol" pl={2}>
              {list.reduce((acc, item) => {
                if (item.type === "pre-license") {
                  return [...acc, <CredentialItem key={item.id} data={item} />];
                } else {
                  return acc;
                }
              }, [])}
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            mb: 1.5,
          }}
        >
          <Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography variant="h5">Membership:</Typography>
              <Button
                sx={{
                  p: 0,
                  "&:hover": {
                    backgroundColor: "transparent",
                  },
                }}
                onClick={() => addNew("membership")}
              >
                Add new
              </Button>
            </Box>
            <Box component="ol" pl={2}>
              {list.reduce((acc, item) => {
                if (item.type === "membership") {
                  return [...acc, <CredentialItem key={item.id} data={item} />];
                } else {
                  return acc;
                }
              }, [])}
            </Box>
          </Box>
        </Box>
        {displayPsypact ? (
          <Box
            sx={{
              mb: 1.5,
              mt: 2,
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={psypactChecked}
                  onChange={handlePsypactChange}
                  disabled={loading}
                />
              }
              label="PSYPACT"
            />
          </Box>
        ) : null}

        {/* <Box
          sx={{
            mb: 1.5
          }}
        >
          <Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <Typography variant='h5'>Certificate:</Typography>
              {list.filter((item) => item.type === 'certificate').length < 1 && (
                <Button
                  sx={{
                    p: 0,
                    '&:hover': {
                      backgroundColor: 'transparent'
                    }
                  }}
                  onClick={addNew}
                >
                  Add new
                </Button>
              )}
            </Box>
            <Box component='ol' pl={2}>
              {list.reduce((acc, item) => {
                if (item.type === 'certificate') {
                  return [...acc, (
                    <CredentialItem key={item.id} data={item} />
                  )];
                } else {
                  return acc;
                }
              }, [])}
            </Box>
          </Box>
        </Box> */}
      </Box>

      {/* <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        <Button
          variant="contained"
          sx={{
            minWidth: 150,
          }}
          onClick={addNew}
        >
          Add New
        </Button>
      </Box> */}
    </Paper>
  );
};

export default ProfileCredentials;
